import {
  CurrencyCode,
  InventoryViewMode,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inventoryLevelsQueryAtom } from '../_graphql/queryInventoryLevels';
import { inventoryMovementHistoryQueryAtom } from '../_graphql/queryInventoryMovementHistory';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

export const $routeParams = atomFromRoutePath('/inventory/levels/:itemId');

export const $facilityId = atomFromQueryString.string('fac');
export const $levelsListFacilityFilter = atomFromQueryString.string('f');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);
export const $currencyCode = atomFromQueryString.string('c');
export const $viewMode = atomFromQueryString.string('view', 'OurMaterial');
export const $itemName = atomFromQueryString.string('name');

export const $itemId = atom((get) => {
  const params = get($routeParams);
  return params.__didMatch ? params.itemId : undefined;
});

export const $canShowRunningTotals = atom((get) => {
  const itemId = get($itemId);
  const facilityId = get($facilityId);
  return Boolean(itemId && facilityId && facilityId !== 'all');
});

export const $remoteInventoryMovementHistory =
  inventoryMovementHistoryQueryAtom((get) => {
    const itemId = get($itemId);
    const facilityId = get($facilityId);
    const limit = get($limit);
    const offset = get($offset);
    const currencyCode = get($currencyCode);

    if (!itemId) {
      return {
        variables: {
          itemId: '',
          limit: 0,
          offset: 0,
        },
        skip: true,
      };
    }

    return {
      variables: {
        itemId,
        facilityId: facilityId && facilityId !== 'all' ? facilityId : undefined,
        currencyCode: currencyCode as CurrencyCode | undefined,
        limit,
        offset,
      },
      skip: false,
    };
  });

export const $remoteFacilityBreakdown = inventoryLevelsQueryAtom((get) => {
  const itemId = get($itemId);
  const viewMode = get($viewMode) as InventoryViewMode;

  if (!itemId) {
    return {
      variables: { limit: 0, offset: 0 },
      skip: true,
    };
  }

  return {
    variables: {
      itemIds: [itemId],
      viewMode,
      limit: 1000,
      offset: 0,
    },
  };
});

export const $allocateDialogOpen = atom(false);
export const $selectedMovementForAllocation = atom<{
  movementId: string;
  facilityId: string;
} | null>(null);
